import * as Yup from 'yup';

export default () => {
  return {
    Comment: Yup.string()
      .max(450, 'Comment mast be less than 450 characters.')
      .required('Comment field is required'),
  };
};
